import Swal from "sweetalert2";
import React from "react";
import { Button } from "antd";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Card } from "antd";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import { t } from "i18next";
import { withTranslation } from "react-i18next";
import BankTransferForm from "../../components/BankTransferForm";
import AppContext from "../../components/AppContext";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { LeftOutlined } from "@ant-design/icons";
class Index extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }
  componentDidMount() {}
  showToast = (icon, title) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3500,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
    Toast.fire({
      icon: icon,
      title: title,
    });
  };
  setLoading = (_loading) => {
    this.setState({ isLoad: _loading });
  };

  render() {
    const { isInbox } = this.props;
    const { allBankAccountData, getDataBankAccount } = this.context;
    return (
      <>
        <div style={{ flex: 1 }}>
          <div>
            <div className="container-fluid">
              <PageHeader
                HeaderText={t("transfer money")}
                Breadcrumb={
                  isInbox
                    ? [
                        {
                          name: removeSlashesFromPath(window.location.pathname),
                          navigate: window.location.pathname,
                        },
                      ]
                    : null
                }
              />
              {isInbox ? (
                <>
                  <Card
                    title={
                      <Link to={"/client-transfer"}>
                        <Button shape="circle" icon={<LeftOutlined />}></Button>
                      </Link>
                    }
                  >
                    <BankTransferForm
                      t={t}
                      funBankAccounts={getDataBankAccount}
                      resDataBank={allBankAccountData}
                    />
                  </Card>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});

export default connect(mapStateToProps, {})(withTranslation()(Index));
